{
	"title": "Фактури",
	"buttonShowMoreInvoicesTitle": "Покажи още фактури",
	"invoicesTableHeaders": {
		"date": "Дата",
		"invoiceNumber": "Номер на фактура",
		"deliveredQuantity": "Доставено количество",
		"bundledCarbonSavings": "Пакетирани въглеродни редукции",
		"transactionId": "ID на транзакция"
	},
	"errorMessage": "Неуспешно зареждане на фактурите"
}
